<div class="cm-numeric-field">
    @if ($label(); as label) {
        <span class="cm-numeric-field-label">{{ label }}</span>
    }
    <input
        type="text"
        inputmode="decimal"
        class="cm-numeric-field-input"
        [value]="$displayString()"
        [placeholder]="$placeholder()"
        [disabled]="$disabled()"
        (input)="onInput($any($event.target).value)"
        (focus)="onFocus()"
        (blur)="onBlur()"
    />
</div>
